var exports = {
  "X": "xaf9ae18d--f6926c--action",
  "O": "xaf9ae18d--f6926c--nowrap",
};

module.exports = exports;
